<template>
  <v-container max-width="100%" style="margin-top: 2%">

    <v-toolbar style="
          margin-bottom: 10px;
          margin-left: 3px;
          margin-top: 10px;
          border-radius: 10px;
          padding-top: 60px;
          padding-bottom: 20px;
          height: 200px;
        ">
      <v-container>
        <v-form ref="form" v-model="formValidado">
          <v-row>
            <v-col cols="12" sm="4" md="3">
              <v-autocomplete v-model="idEmpresaSelected" :items="empresas" item-text="razao_social"
                item-value="id_empresa" clearable :label="$tc('company.self', 1)" @change="onEmpresaSelectChanged"
                :rules="[(v) => !!v || $t('area.selectCompany')]"></v-autocomplete>
              </v-col>
            <v-col cols="12" sm="4" md="3">
              <v-autocomplete v-model="idClienteSelected" :items="clientesSelect" item-text="nome_cliente"
                item-value="id_cliente" clearable :label="$tc('client.self', 1)" @change="onClienteSelectChanged"
                :disabled="!idEmpresaSelected"></v-autocomplete>
              </v-col>
            <v-col cols="12" sm="4" md="2">
              <v-datetime-picker :label="$t('datetime.startDate')" v-model="dti" :time-picker-props="timeProps"
                :text-field-props="textFieldProps" time-format="HH:mm:ss" date-format="dd/MM/yyyy"
                :clear-text="$t('datetime.close')">
                <template slot="dateIcon">
                  <v-icon>mdi-calendar</v-icon>
                </template>
                <template slot="timeIcon">
                  <v-icon>mdi-clock</v-icon>
                </template>
              </v-datetime-picker>
            </v-col>
            <v-col cols="12" sm="4" md="2">
              <v-datetime-picker :label="$t('datetime.finalDate')" v-model="dtf" :time-picker-props="timeProps"
                :text-field-props="textFieldProps" time-format="HH:mm:ss" date-format="dd/MM/yyyy"
                :clear-text="$t('datetime.close')">
                <template slot="dateIcon">
                  <v-icon>mdi-calendar</v-icon>
                </template>
                <template slot="timeIcon">
                  <v-icon>mdi-clock</v-icon>
                </template>
              </v-datetime-picker>
            </v-col>
            <v-col cols="12" sm="6" md="1" class="d-flex align-center" style="gap: 10px;">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small fab color="primary darken-1" class="white--text" v-bind="attrs" v-on="on"
                    @click="populaRelatorio">
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('operation.search') }}</span>
              </v-tooltip>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-autocomplete v-model="idLinhaSelected" :items="linhasSelect" item-text="nome_linha"
                item-value="id_linha" clearable multiple :label="$tc('line.self', 1)" @change="linhasSelectChanged"
                :disabled="isLinhaSelectDisabled"></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-autocomplete v-model="idVeiculoSelected" :items="veiculosSelect" item-text="numero_ordem"
                item-value="id_veiculo" clearable multiple :label="$tc('vehicle.self', 1)"
                @change="veiculosSelectChanged" :disabled="isVeiculoSelectDisabled"></v-autocomplete>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-toolbar>

    <!-- Indicativo de mês fechado: o período consultado pode atravessar meses já congelados,
         cujas viagens não mudam mais. -->
    <v-alert v-if="mesesFechadosNoPeriodo.length" dense text type="info" icon="mdi-lock-check-outline"
      style="border-radius: 10px; margin-bottom: 10px;">
      <div style="font-weight: 600;">{{ $t('closingMonth.closedTitle') }}</div>
      <div>{{ $t('closingMonth.closedPeriodHint', { meses: mesesFechadosNoPeriodo.join(', ') }) }}</div>
    </v-alert>

    <v-data-table :headers="headersTotal" :items="totalTarifas" dense class="elevation-7" locale="pt"
      :loading="loadingRelatorioTotal" :loading-text="$t('system.messages.loading')" :search="search" :custom-sort="customSortTotal"
      style="border-radius: 10px; margin-bottom: 10px;">
      <template v-slot:top>
        <v-toolbar flat color="white" style="border-radius: 10px;">
          <v-toolbar-title style="color: #4a4a4a">{{ $t('relSubsidy.totalRemuneration') }}</v-toolbar-title>
          <span v-if="cicloPagamentoCaption" class="ml-4 grey--text text--darken-1 text-caption">
            {{ cicloPagamentoCaption }}
          </span>

          <v-spacer></v-spacer>

          <vue-json-to-csv :json-data="totalTarifas" :csv-title="'relatoriosubsidiototal'" separator=";">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" color="primary" dark small class="mb-2 mr-2" fab>
                  <v-icon>mdi-export-variant</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('system.labels.exportToCsv') }}</span>
            </v-tooltip>
          </vue-json-to-csv>

          <ExportTablePdf 
            :title="$t('relSubsidy.totalRemuneration')" 
            :content="totalTarifas" 
            :headers="headersTotal" 
            filename="relatoriosubsidiototal">
          </ExportTablePdf>
        </v-toolbar>
      </template>
      <template v-slot:item.descricao_tipo_veiculo="{ item }">
        <span :style="item.style">{{ item.descricao_tipo_veiculo }}</span>
      </template>
      <template v-slot:item.frota_operacional_media="{ item }">
        <span :style="item.style">{{ item.frota_operacional_media }}</span>
      </template>
      <template v-slot:item.km_total="{ item }">
        <span :style="item.style">{{ item.km_total.toFixed(2) }}</span>
      </template>
      <template v-slot:item.valor_tarifa_km="{ item }">
        <span>{{ item.valor_tarifa_km ? currencyFormatter(item.valor_tarifa_km) : '' }}</span>
      </template>
      <template v-slot:item.valor_tarifa_frota="{ item }">
        <span>{{ item.valor_tarifa_frota ? currencyFormatter(item.valor_tarifa_frota) : '' }}</span>
      </template>
      <template v-slot:item.valor_total="{ item }">
        <span style="font-weight: bold;">{{ currencyFormatter(item.valor_total) }}</span>
      </template>
      <template v-slot:item.valor_total_km="{ item }">
        <span :style="item.style">{{ currencyFormatter(item.valor_total_km) }}</span>
      </template>
      <template v-slot:item.valor_total_frota="{ item }">
        <span :style="item.style">{{ currencyFormatter(item.valor_total_frota) }}</span>
      </template>
      <template v-slot:item.valor_total_mao_obra="{ item }">
        <span :style="item.style">{{ currencyFormatter(item.valor_total_mao_obra || 0) }}</span>
      </template>
      <template v-slot:item.cod_contrato_exibicao="{ item }">
        <v-tooltip top v-if="!isLinhaTotal(item)">
          <template v-slot:activator="{ on }">
            <span v-on="on" :style="item.style">{{ item.cod_contrato_exibicao || '—' }}</span>
          </template>
          <span style="white-space: pre-line;">{{ contratoTooltip(item) }}</span>
        </v-tooltip>
      </template>
      <template v-slot:item.origem_valor_label="{ item }">
        <v-tooltip top v-if="!isLinhaTotal(item)">
          <template v-slot:activator="{ on }">
            <v-chip v-on="on" x-small outlined :color="origemValor(item).color">
              <v-icon v-if="origemValor(item).icon" x-small left>{{ origemValor(item).icon }}</v-icon>
              {{ origemValor(item).label }}
            </v-chip>
          </template>
          <span style="white-space: pre-line;">{{ origemValor(item).tooltip }}</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <v-data-table :headers="headersLinhas" :items="veiculosRelatorio" :sort-by="['n_viagens_merus', 'cod_veiculo']"
      :sort-desc="[true, false]" dense class="elevation-7" locale="pt" :loading="loadingVeiculos"
      :loading-text="$t('system.messages.loading')" :search="search"
      @click:row="(linha) => this.idLinhaRelatorio = linha.id_linha" style="border-radius: 10px; margin-bottom: 10px;">
      <template v-slot:top>
        <v-toolbar flat color="white" style="border-radius: 10px;">
          <v-toolbar-title style="color: #4a4a4a">{{ $t('relSubsidy.vehiclesSlashLines') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="mdi-magnify" :label="$t('system.search')" single-line
            hide-details></v-text-field>
          <v-spacer></v-spacer>

          <!-- <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" color="primary" dark small class="mb-2 mr-2" fab @click="removerFiltros">
                <v-icon>mdi-filter-remove</v-icon>
              </v-btn>
            </template>
  <span>Remover Filtro</span>
  </v-tooltip> -->

          <vue-json-to-csv :json-data="veiculosRelatorio" :csv-title="$t('relSubsidy.title')" separator=";">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" color="primary" dark small class="mb-2 mr-2" fab>
                  <v-icon>mdi-export-variant</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('system.labels.exportToCsv') }}</span>
            </v-tooltip>
          </vue-json-to-csv>

          <export-table-pdf :title="$t('relSubsidy.title')" :content="veiculosRelatorio" :headers="headersLinhas"
            filename="relatoriosubsidio" :subtitle="pdfsubtitle"></export-table-pdf>
        </v-toolbar>
      </template>

      <!-- <template v-slot:item.n_viagens_prefeitura="{ item }">
        <span :style="getConciliacaoStyle(item.n_viagens_prefeitura, item.n_viagens_merus)">{{ item.n_viagens_prefeitura
        }}</span>
      </template>

      <template v-slot:item.n_viagens_validas_prefeitura="{ item }">
        <span :style="getConciliacaoStyle(item.n_viagens_validas_prefeitura, item.n_viagens_validas_merus)">{{
          item.n_viagens_validas_prefeitura }}</span>
      </template>

      <template v-slot:item.valor_total_prefeitura="{ item }">
        <span :style="getConciliacaoStyle(item.valor_total_prefeitura, item.valor_total_merus)">{{
          item.valor_total_prefeitura }}</span>
      </template> -->

      <template v-slot:item.p_viagens_validas_merus="{ item }">
        <PercentItem :value="item.p_viagens_validas_merus"></PercentItem>
      </template>

      <template v-slot:item.valor_total="{ item }">
        <span>{{ currencyFormatter(item.valor_total) }}</span>
      </template>

      <template v-slot:item.valor_km="{ item }">
        <span>{{ currencyFormatter(item.valor_km) }}</span>
      </template>

      <!-- <template v-slot:item.p_viagens_validas_prefeitura="{ item }">
        <PercentItem :value="item.p_viagens_validas_prefeitura"
          :style="getConciliacaoStyle(item.p_viagens_validas_prefeitura, item.p_viagens_validas_merus)"></PercentItem>
      </template> -->

      <template v-slot:footer.prepend>
        <span style="font-weight: bold;">{{ $t('relSubsidy.headersLine.totalValue') }}: {{ currencyFormatter(veiculosRelatorio.reduce((acc, item) => acc + item.valor_total, 0)) }}</span>
      </template>
    </v-data-table>

    <v-row>
      <v-col cols="12" sm="12" md="12">
        <v-data-table :headers="headersViagens" :items="viagensFiltered" sort-by="id_viagem" dense
          class="elevation-7 text-body-2" locale="pt" :loading="loadingViagens"
          :loading-text="$t('system.messages.loading')" :item-class="getViagemStyle"
          style="border-radius: 10px; margin-bottom: 10px;">
          <template v-slot:top>
            <v-toolbar flat color="white" style="border-radius: 10px;">
              <v-toolbar-title style="color: #4a4a4a">{{ titleViagensMerus }}</v-toolbar-title>
              <v-spacer></v-spacer>

              <v-select :items="filtroValidas" v-model="filtroValidasAtivoMerus" item-text="text" item-value="value"
                prepend-icon="mdi-filter"></v-select>

              <v-spacer></v-spacer>

              <vue-json-to-csv :json-data="viagensFiltered" :csv-title="$t('relSubsidy.tripSubsidy')" separator=";">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" color="primary" dark small class="mb-2 mr-2" fab>
                      <v-icon>mdi-export-variant</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('system.labels.exportToCsv') }}</span>
                </v-tooltip>
              </vue-json-to-csv>

              <export-table-pdf :title="$t('relSubsidy.titleTrip')" :content="viagensFiltered" :headers="headersViagens"
                filename="relatoriosubsidioviagens" :subtitle="''"></export-table-pdf>
            </v-toolbar>
          </template>

          <template v-slot:item.valor_viagem="{ item }">
            <span>{{ currencyFormatter(item.valor_viagem) }}</span>
          </template>

          <template v-slot:item.valor_km="{ item }">
            <span>{{ currencyFormatter(item.valor_km) }}</span>
          </template>

          <template v-slot:item.porcentagem_posicoes_enviadas="{ item }">
            <PercentItem :value="item.porcentagem_posicoes_enviadas"></PercentItem>
          </template>

          <template v-slot:item.porcentagem_dentro_rota="{ item }">
            <PercentItem :value="item.porcentagem_dentro_rota"></PercentItem>
          </template>

          <template v-slot:item.porcentagem_cobertura="{ item }">
            <PercentItem :value="item.porcentagem_cobertura"></PercentItem>
          </template>
        </v-data-table>
      </v-col>
      <!-- <v-col cols="12" sm="12" md="6">
        <v-data-table :headers="headersViagens" :items="viagensPrefeituraFiltered" sort-by="id_viagem" dense
          class="elevation-7 text-body-2" locale="pt" :loading="loading" :loading-text="$t('system.messages.loading')"
          :item-class="getViagemStyle" style="border-radius: 10px; margin-bottom: 10px;">
          <template v-slot:top>
            <v-toolbar flat color="white" style="border-radius: 10px;">
              <v-toolbar-title style="color: #4a4a4a">{{ titleViagensPref }}</v-toolbar-title>
              <v-spacer></v-spacer>

              <v-select :items="filtroValidas" v-model="filtroValidasAtivoPref" item-text="text" item-value="value"
                prepend-icon="mdi-filter"></v-select>

              <v-spacer></v-spacer>

              <vue-json-to-csv :json-data="viagensFiltered" :csv-title="$t('relSubsidy.tripSubsidy')" separator=";">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" color="primary" dark small class="mb-2 mr-2" fab>
                      <v-icon>mdi-export-variant</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('system.labels.exportToCsv') }}</span>
                </v-tooltip>
              </vue-json-to-csv>

              <export-table-pdf title="Relatório de Subsídio - Viagens" :content="viagensFiltered"
                :headers="headersViagens" filename="relatoriosubsidioviagens" :subtitle="''"></export-table-pdf>
            </v-toolbar>
          </template>

          <template v-slot:item.valor_viagem="{ item }">
            <span>R$ {{ item.valor_viagem }}</span>
          </template>

          <template v-slot:item.porcentagem_posicoes_enviadas="{ item }">
            <PercentItem :value="item.porcentagem_posicoes_enviadas"></PercentItem>
          </template>

          <template v-slot:item.porcentagem_dentro_rota="{ item }">
            <PercentItem :value="item.porcentagem_dentro_rota"></PercentItem>
          </template>

          <template v-slot:item.porcentagem_cobertura="{ item }">
            <PercentItem :value="item.porcentagem_cobertura"></PercentItem>
          </template>
        </v-data-table>
      </v-col> -->
    </v-row>
  </v-container>
</template>

<script>

import apiController from "@/utils/apiController";
import EventBus from "@/utils/eventBus";
import DateUtils from "../utils/dateutils";
import PercentItem from "./PercentItem.vue";
import VueJsonToCsv from 'vue-json-to-csv';
import ExportTablePdf from './ExportTablePdf.vue';

export default {
  components: {
    PercentItem,
    VueJsonToCsv,
    ExportTablePdf,
  },
  data: () => ({
    search: "",
    user: null,
    token: null,
    showConfirmButton: true,
    formValidado: false,
    loading: false,
    loadingViagens: false,
    loadingVeiculos: false,
    timeProps: {
      useSeconds: true,
    },
    dti: null,
    dtf: null,
    idEmpresaSelected: null,
    idClienteSelected: null,
    clientes: [],
    idVeiculoSelected: [],
    idLinhaSelected: [],
    isLinhaSelectDisabled: false,
    empresas: [],
    veiculosSelect: [],
    linhasSelect: [],
    entradas: [],
    entradasFiltered: [],
    isVeiculoSelectDisabled: false,
    config: null,
    linhas: [],
    veiculosRelatorio: [],
    viagensRelatorio: [],
    viagensPrefeitura: [],
    idLinhaRelatorio: null,
    filtroValidasAtivoMerus: 0,
    filtroValidasAtivoPref: 0,
    totalTarifas: [],
    total: {},
    // Meses já fechados da empresa, para o indicativo do período consultado.
    fechamentosMes: [],
    cicloPagamento: null,
    loadingRelatorioTotal: false,
    parametrosSetup: null,
  }),
  computed: {
    clientesSelect() {
      if (!this.idEmpresaSelected) return [];
      return this.clientes.filter((c) => c.id_empresa == this.idEmpresaSelected);
    },
    /**
     * Períodos fechados (meses em MM/AAAA, dias em DD/MM/AAAA) que se sobrepõem ao período
     * consultado. O período do relatório é livre e pode atravessar vários meses, então o
     * indicativo lista todos.
     */
    mesesFechadosNoPeriodo() {
      if (!this.fechamentosMes.length || !this.dti || !this.dtf) return [];
      const pad = (n) => String(n).padStart(2, '0');
      const chave = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
      const inicio = chave(new Date(this.dti));
      const fim = chave(new Date(this.dtf));
      return this.fechamentosMes
        .filter((f) => {
          const ini = String(f.dt_inicio || f.mes_referencia || '').substring(0, 10);
          const fimF = String(f.dt_fim || ini).substring(0, 10);
          return ini <= fim && fimF >= inicio;
        })
        .map((f) => f.periodo_extenso || f.mes_referencia_extenso)
        .filter(Boolean);
    },
    cicloPagamentoCaption() {
      const c = this.cicloPagamento;
      if (!c || !c.inicio || !c.fim) return '';
      let tipo = this.$t('relSubsidy.paymentCycle.monthly');
      if (c.tipo === 'QUINZENAL') {
        tipo = this.$t('relSubsidy.paymentCycle.biweekly');
      } else if (c.tipo === 'DIAS') {
        tipo = this.$t('relSubsidy.paymentCycle.customDays', {
          dias: c.dias_ciclo_pagamento || c.dias || '?',
        });
      }
      const range = this.$t('relSubsidy.paymentCycle.range', {
        inicio: this.formatCicloDia(c.inicio),
        fim: this.formatCicloDia(c.fim),
      });
      let caption = `${this.$t('relSubsidy.paymentCycle.label')}: ${tipo} (${range})`;
      // Contrato operacional sem ciclo próprio herda o do contrato de controle;
      // dizer de onde veio evita a leitura de que o operacional o define.
      if (c.origem === 'CONTROLE' && c.cod_contrato_ciclo) {
        caption += ` — ${this.$t('relSubsidy.paymentCycle.fromControl', {
          contrato: c.cod_contrato_ciclo,
        })}`;
      }
      return caption;
    },
    headersLinhas() {
      return [
        { text: this.$t('relSubsidy.headersLine.id'), value: "id_veiculo", align: " d-none" },
        { text: this.$t('relSubsidy.headersLine.vehicle'), value: "cod_veiculo" },
        { text: this.$t('relSubsidy.headersLine.type'), value: "descricao_tipo_veiculo" },
        { text: this.$t('relSubsidy.headersLine.tarif'), value: "descricao_tarifa" },
        { text: this.$t('relSubsidy.headersLine.idLine'), value: "id_linha", align: " d-none" },
        { text: this.$t('relSubsidy.headersLine.line'), value: "cod_linha" },
        { text: this.$t('relSubsidy.headersLine.trip'), value: "n_viagens_merus" },
        // { text: this.$t('relSubsidy.headersLine.tripCityHall'), value: "n_viagens_prefeitura" },
        { text: this.$t('relSubsidy.headersLine.valid'), value: "n_viagens_validas_merus" },
        // { text: this.$t('relSubsidy.headersLine.validCityHall'), value: "n_viagens_validas_prefeitura" },
        { text: this.$t('relSubsidy.headersLine.validPercent'), value: "p_viagens_validas_merus" },
        // { text: this.$t('relSubsidy.headersLine.validPercentCityHall'), value: "p_viagens_validas_prefeitura" },
        { text: this.$t('relSubsidy.headersLine.km'), value: "km_total" },
        { text: this.$t('relSubsidy.headersLine.valuePerKm'), value: "valor_km" },
        { text: this.$t('relSubsidy.headersLine.totalValue'), value: "valor_total" },
        // { text: this.$t('relSubsidy.headersLine.totalValueCityHall'), value: "valor_total_prefeitura" }
      ]
    },
    textFieldProps() {
      return {
        prependInnerIcon: "mdi-calendar",
        rules: [(v) => !!v || this.$t('contract.messages.selectDate')], // (v) => v > this.dtfimbase || "Data início deve ser menor que data fim !"]
      }
    },
    filtroValidas() {
      return [
        { text: this.$t('conciliation.all'), value: 0 },
        { text: this.$t('relSubsidy.headersLine.valid'), value: 1 },
        { text: this.$t('relSubsidy.invalids'), value: 2 },
        { text: this.$t('relSubsidy.cancelled'), value: 3 }]
    },
    headersTotal() {
      const h = [
        { text: this.$t('relSubsidy.headersTotal.typeVehicle'), value: "descricao_tipo_veiculo" },
        { text: this.$t('relSubsidy.headersTotal.tarifFleet'), value: "descricao_tarifa_frota" },
        { text: this.$t('relSubsidy.headersTotal.valueTarifFleet'), value: "valor_tarifa_frota" },
        { text: this.$t('relSubsidy.headersTotal.averageOperationalFleet'), value: "frota_operacional_media" },
        { text: this.$t('relSubsidy.headersTotal.valueFleetTotal'), value: "valor_total_frota" },
        { text: this.$t('relSubsidy.headersTotal.tarifKm'), value: "descricao_tarifa_km" },
        { text: this.$t('relSubsidy.headersTotal.valueTarifKm'), value: "valor_tarifa_km" },
        { text: this.$t('relSubsidy.headersTotal.totalKm'), value: "km_total" },
        { text: this.$t('relSubsidy.headersTotal.valueKmTotal'), value: "valor_total_km" },
      ];
      // Mão de obra só existe como linha de valor do contrato novo: a coluna
      // aparece quando algum tipo de veículo a tem.
      if (this.totalTarifas.some((t) => Number(t.valor_total_mao_obra) > 0)) {
        h.push({ text: this.$t('relSubsidy.headersTotal.valueLaborTotal'), value: "valor_total_mao_obra" });
      }
      h.push(
        { text: this.$t('relSubsidy.headersTotal.total'), value: "valor_total" },
        { text: this.$t('relSubsidy.headersTotal.contract'), value: "cod_contrato_exibicao", sortable: false },
        { text: this.$t('relSubsidy.headersTotal.valueOrigin'), value: "origem_valor_label", sortable: false }
      );
      return h;
    },
    headersViagens() {
      return [
        { text: this.$t('relSubsidy.headersTrip.id'), value: "id_viagem", align: " d-none" },
        { text: this.$t('relSubsidy.headersTrip.start'), value: "dt_inicio_extenso" },
        { text: this.$t('relSubsidy.headersTrip.end'), value: "dt_fim_extenso" },
        { text: this.$t('relSubsidy.headersTrip.direction'), value: "descricao_sentido" },
        { text: this.$t('relSubsidy.headersTrip.km'), value: "km_total" },
        { text: this.$t('relSubsidy.headersTrip.valuePerKm'), value: "valor_km" },
        { text: this.$t('relSubsidy.headersTrip.value'), value: "valor_viagem" },
        // { text: this.$t('relSubsidy.headersTrip.coveringPercentage'), value: "porcentagem_cobertura" },
        // { text: this.$t('relSubsidy.headersTrip.routePercentage'), value: "porcentagem_dentro_rota" },
        // { text: this.$t('relSubsidy.headersTrip.sendPercentage'), value: "porcentagem_posicoes_enviadas" },
        { text: this.$t('relSubsidy.headersTrip.line'), value: "cod_linha" },
        { text: this.$t('relSubsidy.headersTrip.vehicle'), value: "cod_veiculo" },
        { text: this.$t('relSubsidy.headersTrip.authorized'), value: "autorizado_prefeitura_extenso" },
        { text: this.$t('relSubsidy.headersTrip.duration'), value: "tempo_viagem" },
      ];
    },
    pdfsubtitle() {
      return "";
    },
    viagensFiltered() {
      let v = this.viagensRelatorio;

      if (this.idLinhaRelatorio) {
        v = v.filter((v) => v.id_linha == this.idLinhaRelatorio);
      }

      if (this.filtroValidasAtivoMerus === 1) {
        v = v.filter((v) => v.viagem_valida == 1 && v.conciliacao_cancelada == 0);
      } else if (this.filtroValidasAtivoMerus === 2) {
        v = v.filter((v) => v.viagem_valida == 0 && v.conciliacao_cancelada == 0);
      } else if (this.filtroValidasAtivoMerus === 3) {
        v = v.filter((v) => v.conciliacao_cancelada == 1);
      }

      return v;
    },
    // viagensPrefeituraFiltered() {
    //   let v = this.viagensPrefeitura;

    //   if (this.idLinhaRelatorio) {
    //     v = v.filter((v) => v.id_linha == this.idLinhaRelatorio);
    //   }

    //   if (this.filtroValidasAtivoPref === 1) {
    //     v = v.filter((v) => v.valida_viagem == 1);
    //   } else if (this.filtroValidasAtivoPref === 2) {
    //     v = v.filter((v) => v.valida_viagem == 0);
    //   }

    //   return v;
    // },
    titleViagensMerus() {
      return `${this.$tc('trip.self', 1)} ${this.idLinhaRelatorio ? '(' + this.linhas.find((l) => this.idLinhaRelatorio == l.id_linha).cod_linha + ')' : ''}`;
    },
    // titleViagensPref() {
    //   return `Viagens Prefeitura ${this.idLinhaRelatorio ? '(' + this.linhas.find((l) => this.idLinhaRelatorio == l.id_linha).cod_linha + ')' : ''}`;
    // },
    // Computed property reativa para formatação de moeda
    currencyFormatter() {
      const currencyCode = this.$t('contract.currencyCode') || 'BRL';
      const localeCode = this.$t('contract.localeCode') || 'pt-BR';
      
      return (value) => {
        if (value === null || value === undefined) return '';
        return new Intl.NumberFormat(localeCode, {
          style: 'currency',
          currency: currencyCode,
          minimumFractionDigits: 2,
          maximumFractionDigits: 4
        }).format(value);
      };
    }
  },
  watch: {
    '$i18n.locale'() {
      this.initialize();
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    }
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.token = sessionStorage.getItem("api");
    this.initialize();
  },
  mounted() { },
  methods: {

    initialize() {
      this.getConfig();
      this.populaEmpresas();
      this.populaClientes();
      this.populaLinhas();
    },
    async getConfig() {
      try {
        const [cfgRes, parRes] = await Promise.all([
          apiController.request(apiController.endpoints.getallConfig, { silent: true }),
          apiController.request(apiController.endpoints.getallParametrossetup, { silent: true })]);
        this.config = cfgRes.data[0];
        this.parametrosSetup = parRes.data[0];
        [this.dti, this.dtf] = DateUtils.setDefaultDateFilters(this.config.hora_inicial_dia_operacao);
      } catch (e) {
        EventBus.$emit('show-error', { error: e });
      }
    },
    customSortTotal(items, index, isDescending) {
      // Separa a linha "total" das demais
      const totalItem = items.find(item => item.descricao_tipo_veiculo === this.$t('relSubsidy.headersTotal.total'));
      const regularItems = items.filter(item => item.descricao_tipo_veiculo !== this.$t('relSubsidy.headersTotal.total'));
      
      // Se não há index (sortBy), retorna os items na ordem original
      if (!index || index.length === 0) {
        return totalItem ? [...regularItems, totalItem] : regularItems;
      }

      // Ordena os items regulares de acordo com os critérios especificados
      const sortedItems = regularItems.sort((a, b) => {
        // Permite múltiplos critérios de ordenação
        const sortByArray = Array.isArray(index) ? index : [index];
        const isDescArray = Array.isArray(isDescending) ? isDescending : [isDescending];

        for (let i = 0; i < sortByArray.length; i++) {
          const sortKey = sortByArray[i];
          const isDesc = isDescArray[i];

          let aVal = a[sortKey];
          let bVal = b[sortKey];

          // Tratamento para valores null/undefined
          if (aVal === null || aVal === undefined) aVal = '';
          if (bVal === null || bVal === undefined) bVal = '';

          // Comparação numérica ou string
          let comparison = 0;
          if (typeof aVal === 'number' && typeof bVal === 'number') {
            comparison = aVal - bVal;
          } else {
            comparison = String(aVal).localeCompare(String(bVal), 'pt-BR', { numeric: true });
          }

          if (comparison !== 0) {
            return isDesc ? -comparison : comparison;
          }
        }
        return 0;
      });

      // Retorna os items ordenados com o total no final
      return totalItem ? [...sortedItems, totalItem] : sortedItems;
    },
    populaEmpresas() {
      apiController.request(apiController.endpoints.getallEmpresas, {
        onSuccess: (response) => {
          this.empresas = response.data;
        },
      });
    },
    populaClientes() {
      apiController.request(apiController.endpoints.getallClientes, {
        onSuccess: (response) => {
          const list = Array.isArray(response.data) ? response.data : [];
          this.clientes = list
            .filter((c) => c.ativo === 1 || c.ativo === true || c.ativo == null)
            .sort((a, b) =>
              String(a.nome_cliente || "").localeCompare(String(b.nome_cliente || ""), undefined, {
                sensitivity: "base",
              })
            );
        },
      });
    },
    resolveIdLinhasFilter() {
      if (this.idLinhaSelected.length > 0) {
        return this.idLinhaSelected;
      }
      if (!this.idClienteSelected) {
        return null;
      }
      const ids = this.linhasSelect.map((l) => l.id_linha);
      return ids.length > 0 ? ids : null;
    },
    populaVeiculosSelect(id_empresa) {
      apiController.request(apiController.endpoints.getVeiculoporempresa, {
        params: { id: id_empresa },
        onSuccess: (response) => {
          this.veiculosSelect = response.data;
        },
      });
    },
    populaLinhas() {
      apiController.request(apiController.endpoints.getLinhasativas, {
        onSuccess: (response) => {
          this.linhas = response.data;
        },
      });
    },
    populaLinhasSelect() {
      let list = this.linhas.filter((l) => l.id_empresa == this.idEmpresaSelected);
      if (this.idClienteSelected) {
        list = list.filter((l) => l.id_cliente == this.idClienteSelected);
      }
      this.linhasSelect = list;
    },
    populaViagensRelatorio() {
      this.loadingViagens = true;
      let dataInicial = DateUtils.getDateSQLFormatted(this.dti);
      let dataFinal = DateUtils.getDateSQLFormatted(this.dtf);

      let body = {
        dti: dataInicial,
        dtf: dataFinal,
        idempresa: this.idEmpresaSelected || null,
        idcliente: this.idClienteSelected || null,
        idlinhas: this.resolveIdLinhasFilter(),
        idveiculos: this.idVeiculoSelected.length > 0 ? this.idVeiculoSelected : null,
      };

      apiController.request(apiController.endpoints.subsidioGetRelatorioviagensdatacontrato, {
        data: body,
        onSuccess: (response) => {
          this.viagensRelatorio = response.data;
          this.loadingViagens = false;
        },
        onError: () => {
          this.loadingViagens = false;
        },
      });
    },
    populaVeiculosRelatorio() {
      this.loadingVeiculos = true;
      let dataInicial = DateUtils.getDateSQLFormatted(this.dti);
      let dataFinal = DateUtils.getDateSQLFormatted(this.dtf);

      let body = {
        dti: dataInicial,
        dtf: dataFinal,
        idempresa: this.idEmpresaSelected || null,
        idcliente: this.idClienteSelected || null,
        idlinhas: this.resolveIdLinhasFilter(),
        idveiculos: this.idVeiculoSelected.length > 0 ? this.idVeiculoSelected : null,
      };

      apiController.request(apiController.endpoints.subsidioGetRelatorioveiculosdatacontrato, {
        data: body,
        onSuccess: (response) => {
          this.veiculosRelatorio = response.data;
          this.loadingVeiculos = false;
        },
        onError: () => {
          this.loadingVeiculos = false;
        },
      });
    },
    // populaViagensPrefeitura() {
    //   axios
    //     .post(ApiBaseUrl + `/api/v1.0/getsubsidioviagensdataprefeitura`, body, {
    //       headers: { "x-access-token": this.token },
    //     })
    //     .then((response) => {
    //       this.viagensPrefeitura = response.data;
    //       if (this.viagensRelatorio.length > 0) {
    //         let linhaAgregado = {
    //           id_linha: this.viagensRelatorio[0].id_linha,
    //           cod_linha: this.viagensRelatorio[0].cod_linha,
    //           n_viagens_merus: 1,
    //           n_viagens_validas_merus:
    //             this.viagensRelatorio[0].valida_posicoes_enviadas == 1 && this.viagensRelatorio[0].valida_posicoes_na_rota == 1 ? 1 : 0,
    //           p_viagens_validas_merus: 0,
    //           valor_por_viagem: this.viagensRelatorio[0].valor_viagem,
    //           valor_total_merus: this.viagensRelatorio[0].valor_viagem,
    //           distancia_km: this.viagensRelatorio[0].distancia_km,
    //           n_viagens_prefeitura: 0,
    //           n_viagens_validas_prefeitura: 0,
    //           p_viagens_validas_prefeitura: 0,
    //           valor_total_prefeitura: 0
    //         };

    //         for (let i = 1; i < this.viagensRelatorio.length; i++) {
    //           if (this.viagensRelatorio[i].id_linha !== this.viagensRelatorio[i - 1].id_linha) {
    //             linhaAgregado.valor_por_viagem = `R$ ${parseFloat(linhaAgregado.valor_por_viagem).toFixed(2)}`;
    //             linhaAgregado.valor_total_merus = `R$ ${parseFloat(linhaAgregado.valor_total_merus).toFixed(2)}`;
    //             linhaAgregado.p_viagens_validas_merus = Math.round(linhaAgregado.n_viagens_validas_merus * 100 / linhaAgregado.n_viagens_merus);
    //             linhaAgregado.distancia_km = parseFloat(linhaAgregado.distancia_km).toFixed(2);
    //             this.linhasRelatorio.push(linhaAgregado);

    //             linhaAgregado = {
    //               id_linha: this.viagensRelatorio[i].id_linha,
    //               cod_linha: this.viagensRelatorio[i].cod_linha,
    //               n_viagens_merus: 1,
    //               n_viagens_validas_merus:
    //                 this.viagensRelatorio[i].valida_posicoes_enviadas == 1 && this.viagensRelatorio[i].valida_posicoes_na_rota == 1 && this.viagensRelatorio[i].valida_cobertura == 1 ? 1 : 0,
    //               p_viagens_validas_merus: 0,
    //               valor_por_viagem: this.viagensRelatorio[i].valor_viagem,
    //               valor_total_merus: this.viagensRelatorio[i].valor_viagem,
    //               distancia_km: this.viagensRelatorio[i].distancia_km,
    //               // n_viagens_prefeitura: 0,
    //               // n_viagens_validas_prefeitura: 0,
    //               // p_viagens_validas_prefeitura: 0,
    //               // valor_total_prefeitura: 0
    //             };
    //           } else {
    //             linhaAgregado.n_viagens_merus += 1;
    //             linhaAgregado.n_viagens_validas_merus += this.viagensRelatorio[i].valida_viagem == 1 ? 1 : 0;
    //             linhaAgregado.valor_total_merus += this.viagensRelatorio[i].valor_viagem;
    //             linhaAgregado.distancia_km += this.viagensRelatorio[i].distancia_km;
    //           }
    //         }

    //         linhaAgregado.valor_por_viagem = `R$ ${parseFloat(linhaAgregado.valor_por_viagem).toFixed(2)}`;
    //         linhaAgregado.valor_total_merus = `R$ ${parseFloat(linhaAgregado.valor_total_merus).toFixed(2)}`;
    //         linhaAgregado.p_viagens_validas_merus = Math.round(linhaAgregado.n_viagens_validas_merus * 100 / linhaAgregado.n_viagens_merus);
    //         linhaAgregado.distancia_km = parseFloat(linhaAgregado.distancia_km).toFixed(2);
    //         this.linhasRelatorio.push(linhaAgregado);
    //       }

    //       if (this.viagensPrefeitura.length > 0) {
    //         for (let linha of this.linhasRelatorio) {
    //           let viagensLinha = this.viagensPrefeitura.filter((v) => v.id_linha == linha.id_linha);
    //           if (viagensLinha.length > 0) {
    //             viagensLinha.forEach((v) => {
    //               linha.n_viagens_prefeitura += 1;
    //               linha.n_viagens_validas_prefeitura += v.valida_viagem == 1 ? 1 : 0;
    //               linha.valor_total_prefeitura += v.valor_viagem;
    //             });
    //             linha.p_viagens_validas_prefeitura = Math.round(linha.n_viagens_validas_prefeitura * 100 / linha.n_viagens_prefeitura);
    //             linha.valor_total_prefeitura = `R$ ${parseFloat(linha.valor_total_prefeitura).toFixed(2)}`;
    //           } else {
    //             linha.valor_total_prefeitura = `R$ ${parseFloat(linha.valor_total_prefeitura).toFixed(2)}`;
    //           }
    //         }
    //       } else {
    //         for (let linha of this.linhasRelatorio) {
    //           linha.valor_total_prefeitura = `R$ ${parseFloat(linha.valor_total_prefeitura).toFixed(2)}`;
    //         }
    //       }

    //       this.loading = false;
    //     })
    //     .catch((e) => {
    //       this.loading = false;
    //       console.log(this.$t('system.messages.errorAxios'));
    //       console.log(e.message);
    //       if (e.message == "Request failed with status code 401") {
    //         this.mensagemAutorizacaoDialog =
    //           this.$t('system.messages.accessDenied');
    //         this.autorizacaoDialog = true;
    //       }
    //     });
    // },
    populaRelatorio() {
      this.$refs.form.validate();
      if (this.formValidado) {
        this.linhasRelatorio = [];
        this.carregaFechamentosMes();
        this.populaVeiculosRelatorio();
        this.populaViagensRelatorio();
        this.populaRelatorioTotal();
        this.$nextTick(() => { this.$refs.form.resetValidation(); });
      }
    },
    carregaFechamentosMes() {
      if (!this.idEmpresaSelected) {
        this.fechamentosMes = [];
        return;
      }
      apiController.request(apiController.endpoints.subsidioGetallFechamentosmes, {
        data: { idempresa: this.idEmpresaSelected, somente_ativos: true },
        silent: true,
        onSuccess: (response) => {
          this.fechamentosMes = Array.isArray(response.data) ? response.data : [];
        },
        onError: () => {
          // Sem permissão de leitura o indicativo apenas não aparece.
          this.fechamentosMes = [];
        },
      });
    },
    populaRelatorioTotal() {
      this.loadingRelatorioTotal = true;
      let payload = {
        dti: DateUtils.getDateSQLFormatted(this.dti),
        dtf: DateUtils.getDateSQLFormatted(this.dtf),
        idempresa: this.idEmpresaSelected || null,
        idcliente: this.idClienteSelected || null,
        idlinhas: this.resolveIdLinhasFilter(),
        idveiculos: this.idVeiculoSelected.length > 0 ? this.idVeiculoSelected : null,
      };

      apiController.request(apiController.endpoints.subsidioFriburgoGetSubsidiototal, {
        data: payload,
        onSuccess: (response) => {
          // Só entram as linhas em que houve km e/ou frota, independente das
          // linhas cadastradas no contrato.
          const tarifas = (response.data.tarifas || []).filter(
            (r) => Number(r.km_total) > 0 || Number(r.frota_operacional_media) > 0
          );
          const tot = response.data.total || {};
          // Rótulo em campo plano: o slot da tabela usa `origemValor()`, mas o
          // CSV e o PDF exportam o valor cru da coluna e precisam do texto.
          tarifas.forEach((r) => {
            r.cod_contrato_exibicao = this.codContratoExibicao(r);
            r.origem_valor_label = this.origemValor(r).label;
          });
          this.totalTarifas = [...tarifas];
          this.total = { ...tot };
          this.cicloPagamento = response.data.ciclo_pagamento || null;
          this.totalTarifas.push({
            descricao_tipo_veiculo: this.$t('relSubsidy.headersTotal.total'),
            frota_operacional_media: this.total.frota_operacional_media,
            km_total: this.total.km_total,
            valor_total_km: this.total.valor_total_km,
            valor_total_frota: this.total.valor_total_frota,
            valor_total_mao_obra: this.total.valor_total_mao_obra || 0,
            valor_total: this.total.valor_total,
            style: 'font-weight: bold;',
          });
          this.loadingRelatorioTotal = false;
        },
        onError: () => {
          this.loadingRelatorioTotal = false;
          this.cicloPagamento = null;
        },
      });
    },
    /** A última linha da tabela é a de somatório, não uma linha de contrato. */
    isLinhaTotal(item) {
      return item.descricao_tipo_veiculo === this.$t('relSubsidy.headersTotal.total');
    },
    /**
     * Código do contrato que identifica a linha.
     *
     * O relatório resolve a tarifa pelo contrato operacional, mas quem
     * representa o acordo comercial é o contrato de controle vinculado a ele —
     * é esse que o cliente reconhece. O operacional fica como fallback (e
     * sempre visível no tooltip) para quando não há controle vinculado.
     */
    codContratoExibicao(item) {
      return item.cod_contrato_controle || item.cod_contrato_valor || '';
    },
    /** Detalha os dois contratos por trás da coluna: controle e operacional. */
    contratoTooltip(item) {
      const t = (k) => this.$t(`relSubsidy.valueOrigin.${k}`);
      const linhas = [];
      if (item.cod_contrato_controle) {
        linhas.push(`${t('controlContract')}: ${item.cod_contrato_controle}`);
      }
      if (item.cod_contrato_valor) {
        linhas.push(`${t('operationalContract')}: ${item.cod_contrato_valor}`);
      }
      return linhas.length ? linhas.join('\n') : t('noContract');
    },
    /**
     * Explica de onde saiu o `valor_total` da linha: da fórmula cadastrada no
     * banco, da composição fixa do sistema, ou da composição fixa depois de a
     * fórmula falhar — caso em que o motivo do erro vai no tooltip.
     */
    origemValor(item) {
      const t = (k) => this.$t(`relSubsidy.valueOrigin.${k}`);
      const contrato = item.cod_contrato_valor
        ? `${t('operationalContract')}: ${item.cod_contrato_valor}`
        : t('noContract');
      const controle = item.cod_contrato_controle
        ? `${t('controlContract')}: ${item.cod_contrato_controle}`
        : null;
      // A fórmula pode estar cadastrada no contrato de controle, e não no
      // operacional que rege a linha; só mostra a origem quando difere.
      const origemFormula =
        item.cod_contrato_calculo && item.cod_contrato_calculo !== item.cod_contrato_valor
          ? `${t('formulaContract')}: ${item.cod_contrato_calculo}`
          : null;

      if (item.valor_total_origem === 'LINHAS') {
        return {
          label: t('lines'),
          color: 'primary',
          icon: 'mdi-format-list-bulleted',
          tooltip: [t('linesTooltip'), ...this.descreveLinhasValor(item), controle, contrato]
            .filter(Boolean)
            .join('\n'),
        };
      }

      if (item.valor_total_origem === 'FORMULA') {
        const calculo = item.calculo_valor_codigo
          ? `${t('calc')}: ${item.calculo_valor_codigo}`
          : t('formula');
        return {
          label: item.calculo_valor_codigo || t('formula'),
          color: 'primary',
          icon: 'mdi-function-variant',
          tooltip: [t('formulaTooltip'), calculo, controle, contrato, origemFormula]
            .filter(Boolean)
            .join('\n'),
        };
      }

      if (item.valor_total_formula_erro) {
        const calculo = item.calculo_valor_codigo
          ? `${t('calc')}: ${item.calculo_valor_codigo}`
          : null;
        return {
          label: t('standard'),
          color: 'warning',
          icon: 'mdi-alert-outline',
          tooltip: [
            t('errorTooltip'),
            calculo,
            controle,
            contrato,
            origemFormula,
            `${t('reason')}: ${item.valor_total_formula_erro}`,
          ]
            .filter(Boolean)
            .join('\n'),
        };
      }

      return {
        label: t('standard'),
        color: 'grey',
        icon: null,
        tooltip: [t('standardTooltip'), controle, contrato].filter(Boolean).join('\n'),
      };
    },
    /** Uma linha de texto por linha de valor: `tarifa: valor × grandeza (qtd) = total`. */
    descreveLinhasValor(item) {
      const t = (k, p) => this.$t(`relSubsidy.valueOrigin.${k}`, p);
      return (item.linhas_valor || []).flatMap((l) => {
        const qtd = l.quantidade != null ? Number(l.quantidade).toLocaleString(this.$t('contract.localeCode') || 'pt-BR') : '—';
        let txt = `${l.descricao_tarifa || l.cod_tarifa}: ${this.currencyFormatter(l.valor || 0)} × ` +
          `${l.grandeza_codigo || '—'} (${qtd}) = ${this.currencyFormatter(l.valor_total || 0)}`;
        if (l.filtro_codigo) {
          txt += ` · ${t('filter')} ${l.filtro_codigo}`;
          if (l.filtro_chaves_avaliadas != null) {
            txt += ` (${t('filterApproved', { aprovadas: l.filtro_chaves_aprovadas, avaliadas: l.filtro_chaves_avaliadas })})`;
          }
        }
        if (l.aviso) txt += ` ⚠ ${t(`warnings.${l.aviso}`)}`;
        // Mão de obra por faixa: quantos veículos caíram em cada faixa.
        const locale = this.$t('contract.localeCode') || 'pt-BR';
        const usos = (l.faixas_uso || []).map(
          (u) =>
            `   · ${this.$t(`contractV2.laborRegime${u.codigo}`)}: ` +
            `${t('rangeUsage', {
              veiculos: u.veiculos,
              preco: this.currencyFormatter(u.preco),
              veiculoMes: Number(u.veiculo_mes).toLocaleString(locale, { maximumFractionDigits: 3 }),
            })}`,
        );
        return [txt].concat(usos);
      });
    },
    formatCicloDia(ymd) {
      if (!ymd) return '';
      const s = String(ymd);
      if (s.length < 10) return s;
      const [y, m, d] = s.substring(0, 10).split('-');
      return `${d}/${m}/${y}`;
    },
    linhasSelectChanged() {

    },
    veiculosSelectChanged() {

    },
    onEmpresaSelectChanged() {
      this.idClienteSelected = null;
      this.idLinhaSelected = [];
      this.populaLinhasSelect();
      this.populaVeiculosSelect(this.idEmpresaSelected);
    },
    onClienteSelectChanged() {
      this.idLinhaSelected = [];
      this.populaLinhasSelect();
    },
    removerFiltros() {
      this.idLinhaRelatorio = null;
    },
    getViagemStyle(item) {
      if (item.conciliacao_cancelada == 1) {
        return "viagem_cancelada";
      }

      let item_class = item.viagem_valida == 1 ? "viagem__valida" : "viagem__invalida";
      return item_class;
    },
    getConciliacaoStyle(pref, merus) {
      if (pref >= merus) {
        return { color: "green", fontWeight: "bold" }
      }

      return { color: "red", fontWeight: "bold" };
    }

  },
};
</script>

<style>
.viagem__valida {
  font-weight: bold;
  color: green;
}

.viagem__invalida {
  font-weight: bold;
  color: red;
}

.viagem_cancelada {
  color: grey;
}
</style>